import { render, staticRenderFns } from "./ModuleNetwork.vue?vue&type=template&id=22131cf5&scoped=true"
import script from "./ModuleNetwork.vue?vue&type=script&lang=js"
export * from "./ModuleNetwork.vue?vue&type=script&lang=js"
import style0 from "./ModuleNetwork.vue?vue&type=style&index=0&id=22131cf5&prod&lang=scss&scoped=true"
import style1 from "./ModuleNetwork.vue?vue&type=style&index=1&id=22131cf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22131cf5",
  null
  
)

export default component.exports